import React from 'react';
import {Stack, Typography} from '@mui/material';

export type BulletItem = string | {label: string; children: BulletItem[]};

export const TextBulletList: React.FC<{
  items: BulletItem[];
  title?: string;
}> = ({items, title}) => {
  return (
    <Stack>
      {title && <Typography variant={'subtitle1'}>{title}</Typography>}
      <Stack
        component={'ul'}
        paddingLeft={2}
        spacing={0.5}
        sx={{listStyleType: 'disc'}}
        margin={0.2}>
        {items.map((item, index) => {
          if (typeof item === 'string') {
            if (!item.trim().length) return null;
            return (
              <li key={index}>
                <Typography variant={'body1'}>{item}</Typography>
              </li>
            );
          }
          return (
            <li key={item.label}>
              <Typography variant={'body1'}>{item.label}</Typography>
              <TextBulletList items={item.children} />
            </li>
          );
        })}
      </Stack>
    </Stack>
  );
};
